<template>
  <div>
    <div class="modal modal--prize-details" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
        </div>
        <div class="modal__body">
          <img class="modal_icon_alert" src="static/images/modals/level_up.png"/>
          <h1>{{ getTranslations.home_modals_level_up_congratz }}</h1>
          <h1>{{ getTranslations.home_modals_level_up_you_leveled }}</h1>
          <h3>{{ playersDetails.levelUpPoints }} {{ getTranslations.home_modals_level_up_bonus_points_title
            }}</h3>

          <span class="prize-text">{{ getTranslations.home_modals_level_up_win }} {{ playersDetails.gamesToNextLevel }}
            {{ getTranslations.home_modals_level_up_more }} {{ (playersDetails.currentLevel + 1) }}</span>

          <p v-if="facebookFunctionality && getFbPoints !== 0 && !hasShare">
            {{ getTranslations.home_fb_share_share_on }} {{ getFbPoints }} {{ getTranslations.home_fb_share_bonus_points }}
          </p>
          <div class="fb_share"
               v-if="facebookFunctionality && getFbPoints !== 0 && !hasShare">
            <div class="fb_btn btn--icon"
                 @click.prevent="shareLevelUp()">
              <i class="icon-facebook"></i>
              <span>
                {{ getTranslations.home_fb_share_share }}
             </span>
            </div>
          </div>
          <span class="fb_error_msg" v-if="fb_error && facebookFunctionality">{{ getTranslations.home_fb_share_this_fb_account }}</span>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import RoundUpMixin from '@/common/mixins/roundUp';

export default {
  name: 'level-up',
  mixins: [FacebookMixin, RoundUpMixin],
  data() {
    return {
      action: 'LEVEL_UP',
      image: '',
      points: '',
      hasShare: false,
      redirectUrl: '',
      fb_error: false,
    };
  },
  created() {
    this.redirectUrl = `${window.location.href}/${this.userDetails.level}/${this.getLocale || localStorage.getItem('locale')}/`;
    // eslint-disable-next-line
    console.log('redirectUrl: ', this.redirectUrl);
    this.hasAlreadyShare().then((response) => {
      this.getUserLoginDetails().then(() => {
        if (response.data && response.data >= this.userDetails.level) {
          this.hasShare = true;
        } else {
          this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
            // eslint-disable-next-line
            console.log('successful scrapping!');
          });
        }
      });
    });
  },
  mounted() {
    window.FB.XFBML.parse();
  },
  methods: {
    ...mapActions('profile', [
      'getLastSharedLevel',
      'giveContent',
      'getUserLoginDetails',
    ]),
    hasAlreadyShare() {
      return this.getLastSharedLevel();
    },
    assignPoints() {
      this.giveContent({ action: 'LEVEL_UP', points: this.getFbPoints }).then((response) => {
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          this.hasShare = true;
        }
      });
    },
    showError() {
      this.fb_error = true;
    },
    shareLevelUp() {
      this.fb_error = false;
      this.points = this.getFbPoints;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        this.assignPoints,
        this.showError,
      );
    },
  },
  computed: {
    getUrl() {
      return this.redirectUrl;
    },
    getFbPoints() {
      const userPoints = (this.userDetails.facebookId ? this.userDetails.totalPointsEarned : this.userDetails.totalPointsEarned + this.connectionPoints);
      return this.roundUpNumber(Math.floor(userPoints * 0.05));
    },
    ...mapState('game', [
      'playersDetails',
    ]),
    ...mapState('common', [
      'soundsOn',
      'userDetails',
      'facebookFunctionality',
      'connectionPoints',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/LevelUp.vue